import React from 'react'
import { ToastsContainer, ToastsStore, ToastsContainerPosition } from 'react-toasts';
import HeaderComponent from '../Common/header/HeaderComponent';
import FooterComponent from '../Common/footer/FooterComponent';
import CommonNotification from '../Common/commonNotificationActivity/CommonNotificationActivityComponent';



const MainLayout = (props) => {


    return (
        <React.Fragment>
            
                <main className="cr-app bg-light">
                    <HeaderComponent />
                    <section className="main-content-wrapper container d-flex flex-column">
                        <CommonNotification />
                        <div className="content-wrap-inner">
                            {props.children}
                        </div>
                        <FooterComponent />
                    </section>
                </main>
                <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_CENTER} />
            {/* </TourProvider> */}

        </React.Fragment>
    );
}

export default MainLayout
